import { ADD_CHAT_MESSAGE, CLEAR_CHAT_MESSAGES } from './actionTypes';
export const addChatMessage = (message) => ({
    type: ADD_CHAT_MESSAGE,
    payload: message
});
export const clearChatMessages = () => ({
    type: CLEAR_CHAT_MESSAGES
});
